'use client';
import { PropsWithChildren, useEffect } from 'react';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { useKYC } from '@flipster/features/src/shared/kyc';
import { useRouter } from '@flipster/i18n/routing';
import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import segment, { WalletEvent } from '@flipster/utils/segment';

const Template = ({ children }: PropsWithChildren) => {
  const router = useRouter();

  const { kycInfo } = useKYC();
  const { isLoggedIn, isValidKyc } = useAuth();

  const isShowKycAlert = isLoggedIn && !isValidKyc;

  useEffect(() => {
    const KycAlertKey = 'SHOW_KYC_ALERT';
    const isOpenedAlert = sessionStorage?.getItem(KycAlertKey) === 'true';
    if (isShowKycAlert && !isOpenedAlert) {
      dialog.open({
        title: {
          label: 'Identity verification',
        },
        content: 'Required for deposit, withdrawal, and trading',
        buttons: {
          primary: (
            <Dialog.Button
              hierarchy='primary'
              label='Verify now'
              onClick={() => {
                segment.track(WalletEvent.KycVerificationRequireClick, { kyc_level: kycInfo.currentKYCLevel });
                router.push('/user/kyc');
              }}
            />
          ),
          secondary: <Dialog.Button hierarchy='secondary' color='neutral' label='Dismiss' />,
        },
      });
      sessionStorage?.setItem(KycAlertKey, 'true');
    }
  }, [isShowKycAlert, kycInfo.currentKYCLevel, router]);

  return children;
};

export default Template;
